<template>
	<div
		ref="cards"
		class="cards"
		data-cy="cards"
	>
		<div v-if="loading">
			<helio-card
				v-for="(n, index) in skeletonCount"
				:key="index"
				:skeleton="true"
				:width-mode="widthMode"
				:is-ie="isIe"
			/>
		</div>

		<div v-if="!loading">
			<helio-card
				v-for="(item, index) in orderedItems"
				:key="index"
				:item="item"
				:width-mode="widthMode"
				:is-ie="isIe"
				@click="$emit('click', item)"
				@open="$emit('open', item)"
			>
				<slot :item="item" />
			</helio-card>
		</div>
	</div>
</template>

<script>
import _orderBy from 'lodash/orderBy';
import Card from '../card/Card.vue';

export default {
	name: 'Card',

	components: {
		'helio-card': Card,
	},

	props: {
		initialItems: {
			type: [Array, Object],
			required: true,
			description: 'Supplies the content information of each Card to the Cards component',
		},

		loading: {
			type: Boolean,
			required: false,
			default: false,
			description: 'Sets whether the Cards will be shown in their loading state',
		},

		order: {
			type: String,
			required: false,
			default: 'desc',
			validator: value => [
				'asc',
				'desc',
			].indexOf(value) !== -1,
			description: 'Sets whether the ordered Cards will be shown in an ascending or descending sequence',
		},

		orderBy: {
			type: String,
			required: false,
			default: null,
			description: 'Sets whether an item property will be used to order the sequence of cards in the Cards component',
		},

		skeletonCount: {
			type: Number,
			required: false,
			default: 5,
			validator: skeletonCount => skeletonCount >= 0,
			description: 'Sets the number of skeleton Cards to show users during the loading state',
		},
	},

	slots: {
		default: {
			required: true,
			scoped: true,
			description: 'Supplies content to the right-hand section of the Cards component',
		},
	},

	data() {
		return {
			widthMode: 'mobile',
			isIe: false,
			items: null,
		};
	},

	computed: {
		orderedItems() {
			if (
				this.orderBy !== null
				&& this.items
				&& this.items.length > 0
				&& (this.items[0][this.orderBy] !== undefined)
			) {
				return _orderBy(this.items, this.orderBy, this.order);
			}

			return this.items;
		},
	},

	watch: {
		initialItems(newData) {
			this.items = newData;
		},
	},

	mounted() {
		this.onResize();
		this.isIe = this.detectIE();

		window.addEventListener('resize', this.onResize);
		setTimeout(() => {
			this.onResize();
		}, 1000);

		if (this.initialItems) {
			this.items = this.initialItems;
		}
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},

	methods: {
		onResize() {
			setTimeout(() => {
				const { cards } = this.$refs;

				if (cards) {
					const componentWidth = cards.clientWidth;

					if (componentWidth <= 540) {
						this.widthMode = 'mobile';
					} else if (componentWidth <= 640) {
						this.widthMode = 'small';
					} else if (componentWidth <= 920) {
						this.widthMode = 'medium';
					} else {
						this.widthMode = 'regular';
					}
				}
			}, 4);
		},
	},
};
</script>

<style lang="scss" src="./cards.scss" />
